package pl.mothdigital.neuronowi.components.text

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.*
import com.varabyte.kobweb.silk.style.breakpoint.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import pl.mothdigital.neuronowi.theme.*
import pl.mothdigital.neuronowi.theme.text.*

val H2Style = TextBaseStyle.extendedBy {
    base {
        Modifier
            .fontSize(28.px)
            .lineHeight(38.px)
            .fontWeight(FontWeight.Medium)
            .margin(topBottom = 0.px)
    }
    until(Breakpoint.LG) {
        Modifier
            .fontSize(24.px)
            .lineHeight(34.px)
    }
    until(Breakpoint.MD) {
        Modifier
            .fontSize(22.px)
            .lineHeight(32.px)
    }
    until(Breakpoint.SM) {
        Modifier
            .fontSize(20.px)
            .lineHeight(30.px)
    }
}


@Composable
fun AppH2(
    modifier: Modifier = Modifier,
    color: Color = SiteTheme.green._900,
    content: @Composable () -> Unit = {},
) {
    H2(H2Style.toModifier().color(color).then(modifier).toAttrs()) { content() }
}
